export default __webpack_public_path__ + "images/5Z.314c80a.png";